import {
    IPartnerActivationRedirectionRequest,
    IPartnerActivationRedirectionResponse,
} from '../../../../lib/entity/interface/iSubscription';
import { container } from '../../../DataDomain';
import { ISubscriptionRepository } from '../../repositories/interfaces/iSubscriptionRepository';
import { DI } from '@intigral/constant/config/DIContainer';

export interface IPartnerActivationRedirectionUseCase {
    execute(
        payload: IPartnerActivationRedirectionRequest,
        apiToken?: { [key: string]: string }
    ): Promise<IPartnerActivationRedirectionResponse>;
}

export class PartnerActivationRedirectionUseCase implements IPartnerActivationRedirectionUseCase {
    private get subscriptionRepository(): ISubscriptionRepository {
        return container.resolve<ISubscriptionRepository>(DI.REPOSITORIES.ISubscriptionRepository);
    }

    async execute(
        payload: IPartnerActivationRedirectionRequest,
        apiToken?: { [key: string]: string }
    ): Promise<IPartnerActivationRedirectionResponse> {
        return await this.subscriptionRepository.partnerActivationRedirection(payload, apiToken);
    }
}
